<div
  class="mz-form-row medium vertical for-text icon-left-1 artist-search-input-form-row"
  [ngClass]="{ 'icon-right-1': isSearching }">
  @if (selectedArtist && disabledRecentList) {
    <div class="mz-input">
      <div class="mz-item-option small secondary">
        <div class="start">
          <img
            [ngSrc]="selectedArtist.photo ?? '' | mzicImage"
            width="34"
            height="34"
            class="artist__image"
            onerror="this.onerror=null;this.src='assets/images/mocks/TemplateUser4ProfilePicture.png'" />
        </div>
        <div class="mid">
          <strong>
            {{ selectedArtist.name }}
          </strong>
        </div>
        <div class="end">
          @if (selectedArtist.email) {
            <div class="artist__email">
              {{ selectedArtist.email }}
            </div>
          }
          <button
            id="btn-clear"
            (click)="clearArtistSelected()"
            class="mz-button only-icon ghost white"
            type="button">
            <mzic-svg class="w-25" src="assets/icons/mzic-close.svg" />
          </button>
        </div>
      </div>
    </div>
  } @else {
    <div class="mz-input">
      <div class="mz-input-container">
        <input
          type="text"
          data-cy="input-search-artist"
          placeholder="Search..."
          autocomplete="off"
          [(ngModel)]="selectArtistSearchText"
          (ngModelChange)="selectArtistSearchChanged()"
          [ngModelOptions]="{ standalone: true }" />
        <div class="icon left">
          <mzic-svg
            src="assets/icons/mzic-search.svg"
            [ngClass]="{ purple: selectArtistSearchText.length > 0 }" />
        </div>
        @if (isSearching) {
          <div class="icon right">
            <mzic-spinner class="search-artist-spinner"></mzic-spinner>
          </div>
        }
      </div>
    </div>
  }

  @if (showResults) {
    <div class="search-results">
      @for (artist of searchResults; track artist.id) {
        <div
          class="artist"
          data-cy="artist-search-item"
          (click)="selectArtist(artist, false, false)">
          <div class="artist__content">
            <img
              [ngSrc]="artist.photo ?? '' | mzicImage"
              width="34"
              height="34"
              class="artist__image"
              onerror="this.onerror=null;this.src='assets/images/mocks/TemplateUser4ProfilePicture.png'" />
            <div class="artist__name">{{ artist.name }}</div>
          </div>
          <div class="artist__email">{{ artist.email }}</div>
        </div>
      } @empty {
        <div class="empty-text">No results found.</div>
      }
    </div>
  }
</div>
